  import {
    getAccessKeySettings,
    saveAccessKeySettings,
    formatError} from "../../services/AccessKeyService";
  import {formatSuccess} from '../../services/commonServices'

  export const ACCESS_KEYS_LOADING = "ACCESS_KEYS_LOADING";
  export const ACCESS_KEYS_LOADED = "ACCESS_KEYS_LOADED";
  export const ACCESS_KEYS_FAILED = "ACCESS_KEYS_FAILED";
  export const ACCESS_KEYS_SAVED = "ACCESS_KEYS_SAVED";
  
  export const loadAccessKeySettings = () => {
    return (dispatch) => {
      dispatch({ type: ACCESS_KEYS_LOADING });
  
      getAccessKeySettings()
        .then((response) => {
          dispatch({ type: ACCESS_KEYS_LOADED, payload: response.data[0] });
        })
        .catch((error) => {
          const message = formatError(error.response?.data || {});
          dispatch({ type: ACCESS_KEYS_FAILED, payload: message });
        });
    };
  };
  
  export const saveAccessKeySettingsAction = (formData) => {
    return (dispatch) => {
      dispatch({ type: ACCESS_KEYS_LOADING });
      saveAccessKeySettings(formData)
        .then((response) => {
          dispatch({ type: ACCESS_KEYS_SAVED, payload: response.data });
          formatSuccess('Access Key',response)
        })
        .catch((error) => {
          const message = formatError(error.response?.data || {});
          dispatch({ type: ACCESS_KEYS_FAILED, payload: message });
        });
    };
  };